import React, { Component, Fragment } from 'react';
import CountUp from 'react-countup';
import { VictoryChart, VictoryBar, VictoryLabel, VictoryAxis, VictoryPie } from 'victory';

import './style.scss';

const { detect } = require('detect-browser');
const browser = detect();

export default class KeyFacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            data: require('./data.json'),
        };
    }
    handleSelected(key) {
        this.setState({
            selected: key,
        });
    }

    /**
     * Improve how bar charts look by setting the lower y domain to 99% of min
     * This means there's more "distance" between the y values of the items
     */
    getChartDomain = (...values) => {
        if (!values.every(v => typeof v === 'number')) return;
        return;

        /*       let min = Math.min(...values);
        const max = Math.max(...values);

        // Override for the total dividend price, so that the value actually shows
        if (min === 0.28) {
            min = 0.01;
        }

        return {
            y: [min * 0.95, max],
        };*/
    };

    getBarChartLabel = item => d => {
        const addStarSuffix = item.colAYear === '2020' && d.y === 0.28;
        let value = d.y;
        try {
            if (typeof value === 'number') {
                value = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 1 }).format(value);
            }
        } catch (e) {}
        return item.colPrepend + value + item.colAppend + (addStarSuffix ? '*' : '');
    };

    render() {
        const { selected, data } = this.state;
        return (
            <ul className="keyfacts-page">
                {data.items.map((item, key) => (
                    <li key={key} className={item.type}>
                        {item.type === 'number' ? (
                            <Fragment key={key}>
                                <h1>
                                    {item.start}
                                    <CountUp
                                        start={parseFloat(item.number - 3)}
                                        end={parseFloat(item.number)}
                                        decimal={item.decimal ? '.' : null}
                                        decimals={item.decimal ? 1 : 0}
                                    />
                                    {item.end === 'million' ? (
                                        <span className="small">{item.end}</span>
                                    ) : (
                                        item.end
                                    )}
                                </h1>
                                <p>{item.tagline}</p>
                            </Fragment>
                        ) : null}
                        {item.type === 'bar' ? (
                            <Fragment key={key}>
                                <div>
                                    <h2>{item.title}</h2>
                                    {key === selected ? (
                                        <Fragment>
                                            {browser.name === 'ie' &&
                                            browser.version <= 11 ? null : (
                                                <VictoryChart>
                                                    <VictoryBar
                                                        horizontal
                                                        data={item.history}
                                                        barRatio={0.1}
                                                        labels={d =>
                                                            item.colPrepend + d.y + item.colAppend
                                                        }
                                                        style={{
                                                            fontFamily: "'book', sans-serif",
                                                            data: { fill: '#ffd900' },
                                                            labels: { fill: 'black' },
                                                        }}
                                                        labelComponent={
                                                            <VictoryLabel
                                                                dx={-110}
                                                                dy={25}
                                                                style={{
                                                                    fontFamily:
                                                                        "'book', sans-serif",
                                                                    fontSize: 20,
                                                                    fill: '#ffd900',
                                                                }}
                                                            />
                                                        }
                                                    />
                                                    <VictoryAxis
                                                        tickValues={[2020, 2021]}
                                                        style={{
                                                            tickLabels: {
                                                                fontFamily: "'book', sans-serif",
                                                                fontSize: 20,
                                                                fill: '#ffd900',
                                                            },
                                                        }}
                                                        offsetX={58}
                                                    />
                                                </VictoryChart>
                                            )}
                                            {item.historyText ? (
                                                <div
                                                    className="history-text"
                                                    onClick={() => this.handleSelected(null)}
                                                >
                                                    {'Hide ' + item.historyText}
                                                </div>
                                            ) : null}
                                        </Fragment>
                                    ) : (
                                        <Fragment key={key}>
                                            {browser.name === 'ie' && browser.version <= 11 ? (
                                                <img
                                                    alt={item.title}
                                                    className="iefix"
                                                    src={
                                                        'https://files.jdplc.com/images/iefix' +
                                                        item.ie_sub +
                                                        '.png'
                                                    }
                                                />
                                            ) : (
                                                <VictoryChart
                                                    domainPadding={{ x: 60 }}
                                                    height={375}
                                                >
                                                    <VictoryBar
                                                        data={[
                                                            { x: item.colAYear, y: item.colAValue },
                                                            { x: item.colBYear, y: item.colBValue },
                                                        ]}
                                                        domain={this.getChartDomain(
                                                            item.colAValue,
                                                            item.colBValue
                                                        )}
                                                        barRatio={2.2}
                                                        labels={this.getBarChartLabel(item, data)}
                                                        style={{
                                                            fontFamily: "'book', sans-serif",
                                                            data: { fill: '#ffd900' },
                                                            labels: { fill: 'black' },
                                                        }}
                                                        labelComponent={
                                                            <VictoryLabel
                                                                dy={50}
                                                                style={{
                                                                    fontFamily:
                                                                        "'book', sans-serif",
                                                                    fontSize: '25px',
                                                                }}
                                                            />
                                                        }
                                                    />
                                                    <VictoryAxis
                                                        tickValues={[2020, 2021]}
                                                        style={{
                                                            tickLabels: {
                                                                fontFamily: "'book', sans-serif",
                                                                fontSize: 20,
                                                                fill: '#ffd900',
                                                            },
                                                        }}
                                                    />
                                                </VictoryChart>
                                            )}
                                            {/*item.historyText ? (<div className="history-text" onClick={() => this.handleSelected(key)}>{"See " + item.historyText}</div>) : null*/}
                                        </Fragment>
                                    )}
                                </div>
                            </Fragment>
                        ) : null}
                        {item.ieSub === 'total_dividend' && (
                            <div className="total-dividends">
                                *Final dividend withheld in light of COVID-19
                            </div>
                        )}
                        {item.type === 'pie' ? (
                            <Fragment key={key}>
                                <div>
                                    <h2>{item.title}</h2>
                                    {browser.name === 'ie' && browser.version <= 11 ? (
                                        <img
                                            alt={item.title}
                                            className="iefix"
                                            src={
                                                'https://files.jdplc.com/images/iefix' +
                                                item.ie_sub +
                                                '.png'
                                            }
                                        />
                                    ) : (
                                        <Fragment>
                                            <VictoryPie
                                                colorScale={[
                                                    '#ffd900',
                                                    '#ffe00b',
                                                    '#ffe75b',
                                                    '#ffef92',
                                                ]}
                                                height={300}
                                                data={item.data}
                                                labels={d => `${d.x}: ${d.y}%`}
                                                style={{
                                                    labels: {
                                                        fontSize: 0,
                                                        fill: '#000',
                                                    },
                                                    data: {
                                                        stroke: '#000',
                                                        strokeWidth: 1,
                                                    },
                                                }}
                                            />
                                            {item.data.map((item, key) => (
                                                <Fragment>
                                                    <p key={key} className={item.style}>
                                                        {item.x}: {item.y}%
                                                        <span className={item.style}></span>
                                                    </p>
                                                </Fragment>
                                            ))}
                                        </Fragment>
                                    )}
                                </div>
                            </Fragment>
                        ) : null}
                    </li>
                ))}
            </ul>
        );
    }
}
